/*
        This is a generated type file made by our GraphQL code generator
        This file will change as you update your backend schema or any queries and mutations you have in your service

        Please commit and check in changes to these files

        If you have a merge conflicts:
        - Pull in the changes
        - Fix conflicts with the main codebase
        - Rerun the codegen
      */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Coordinates: { input: number[]; output: number[]; }
  CoordinatesScalar: { input: any; output: any; }
  Date: { input: Date; output: Date; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  GeoJSON: { input: import('geojson').Polygon | import('geojson').MultiPolygon; output: import('geojson').Polygon | import('geojson').MultiPolygon; }
  GeoJSONType: { input: "Polygon" | "MultiPolygon"; output: "Polygon" | "MultiPolygon"; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
};

export type Account = {
  __typename?: 'Account';
  balance: Scalars['Int']['output'];
};

export type AddStageInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  address_line_1: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  post_code: Scalars['String']['output'];
  province: Scalars['String']['output'];
};

export type ArchivedItem = {
  __typename?: 'ArchivedItem';
  _id: Scalars['ID']['output'];
  typename: Scalars['String']['output'];
};

export type AssignUsersToStageInput = {
  assigneeIds: Array<Scalars['ID']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  stageId: Scalars['ID']['input'];
};

export type AtkinsOrder = {
  __typename?: 'AtkinsOrder';
  atkinsOrderId: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  signedMapUrl?: Maybe<Scalars['String']['output']>;
  signedReportUrl?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  status?: Maybe<AtkinsOrderStatus>;
  teamId: Scalars['String']['output'];
};

export type AtkinsOrderInput = {
  geometry: GeoJsonInput;
  siteId: Scalars['String']['input'];
};

export enum AtkinsOrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Placed = 'PLACED'
}

export enum AvailableCountryCodes {
  Gb = 'GB',
  Us = 'US'
}

export type BoundaryImage = {
  __typename?: 'BoundaryImage';
  id: Scalars['ID']['output'];
  uri: Scalars['String']['output'];
};

export type Collaborator = {
  __typename?: 'Collaborator';
  _id?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  addresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateProjectInput = {
  developmentType: Array<DevelopmentType>;
  goal?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateThirdPartyOrderInput = {
  quoteId: Scalars['String']['input'];
};

export type CreateThirdPartyQuoteInput = {
  geometry: Scalars['GeoJSON']['input'];
  providerName: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};

export enum CurrencyCode {
  Gbp = 'GBP'
}

export type DeleteSiteInput = {
  siteId: Scalars['ID']['input'];
};

export type DeleteSitesInStageInput = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  stageId: Scalars['ID']['input'];
};

export type DeleteStageInput = {
  stageId: Scalars['ID']['input'];
};

export enum DevelopmentType {
  Commercial = 'COMMERCIAL',
  Industrial = 'INDUSTRIAL',
  MixedUse = 'MIXED_USE',
  Other = 'OTHER',
  Power = 'POWER',
  Residential = 'RESIDENTIAL',
  Retirement = 'RETIREMENT',
  StudentHousing = 'STUDENT_HOUSING'
}

export type Empty = {
  field?: InputMaybe<Scalars['String']['input']>;
};

export type GeoJsonGeometryInput = {
  coordinates: Scalars['CoordinatesScalar']['input'];
  type: Scalars['String']['input'];
};

export type GeoJsonInput = {
  coordinates: Scalars['Coordinates']['input'];
  type: Scalars['GeoJSONType']['input'];
};

export type GetThirdPartyOrderInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

export type Letter = {
  __typename?: 'Letter';
  id?: Maybe<Scalars['String']['output']>;
  recipient_address_line_1?: Maybe<Scalars['String']['output']>;
  recipient_city?: Maybe<Scalars['String']['output']>;
  recipient_country_code?: Maybe<AvailableCountryCodes>;
  recipient_name?: Maybe<Scalars['String']['output']>;
  recipient_post_code?: Maybe<Scalars['String']['output']>;
  recipient_province?: Maybe<Scalars['String']['output']>;
  sender_address_line_1?: Maybe<Scalars['String']['output']>;
  sender_city?: Maybe<Scalars['String']['output']>;
  sender_country_code?: Maybe<AvailableCountryCodes>;
  sender_name?: Maybe<Scalars['String']['output']>;
  sender_post_code?: Maybe<Scalars['String']['output']>;
  sender_province?: Maybe<Scalars['String']['output']>;
  signed_pdf_url?: Maybe<Scalars['String']['output']>;
};

export type LetterInput = {
  bodyText: Scalars['String']['input'];
  bodyTextPage2?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  greeting: Scalars['String']['input'];
  logo?: InputMaybe<UserImage>;
  senderAddressLine1: Scalars['String']['input'];
  senderCity: Scalars['String']['input'];
  senderName: Scalars['String']['input'];
  senderPostcode: Scalars['String']['input'];
  senderProvince: Scalars['String']['input'];
  showSiteBoundary?: InputMaybe<Scalars['Boolean']['input']>;
  signOff?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<UserImage>;
  signaturePage?: InputMaybe<Scalars['Int']['input']>;
  vatRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LetterOptionsInput = {
  hideRecipientAddress?: InputMaybe<Scalars['Boolean']['input']>;
  paperFormat?: InputMaybe<Scalars['String']['input']>;
};

export enum LetterSendStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT',
  WaitingToBeSent = 'WAITING_TO_BE_SENT'
}

export type LetterStatus = {
  __typename?: 'LetterStatus';
  created_at: Scalars['String']['output'];
  status: LetterSendStatus;
};

export type LettersAccess = {
  __typename?: 'LettersAccess';
  isGranted: Scalars['Boolean']['output'];
  reason?: Maybe<LettersAccessDenyReason>;
};

export enum LettersAccessDenyReason {
  ComplexCompanyTree = 'COMPLEX_COMPANY_TREE',
  IsLandAssembly = 'IS_LAND_ASSEMBLY',
  MultipleTitles = 'MULTIPLE_TITLES',
  NotFreehold = 'NOT_FREEHOLD',
  NoTitleAvailable = 'NO_TITLE_AVAILABLE',
  ProcessingError = 'PROCESSING_ERROR',
  UserNotPermitted = 'USER_NOT_PERMITTED'
}

export type MoveAllSitesToStageInput = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sourceStageId: Scalars['ID']['input'];
  targetStageId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addStage: SiteStage;
  archiveProject: Project;
  assignUsersToStage: Array<SiteUpdateResponse>;
  createProject: Project;
  createSiteLetterTemplate: SiteLetterTemplate;
  createSiteLetters: Array<SiteLetter>;
  createThirdPartyOrder: ThirdPartyOrder;
  createThirdPartyQuote: ThirdPartyQuote;
  deleteProject: Scalars['Boolean']['output'];
  deleteProjectFile: Scalars['Boolean']['output'];
  deleteSite: Array<ArchivedItem>;
  deleteSitesInStage: Array<ArchivedItem>;
  deleteStage: Array<ArchivedItem>;
  getProjectFileUploadUrl: ProjectFileUploadPayload;
  moveAllSitesToStage: Array<SiteUpdateResponse>;
  placeAtkinsOrder: PlaceAtkinsOrderResponse;
  processThirdPartyOrder: ThirdPartyOrder;
  registerProjectFileUpload: Scalars['String']['output'];
  restoreProject: Project;
  sendSiteLetters: Array<SiteLetter>;
  updateProject: Project;
  updateSiteLetterTemplate: SiteLetterTemplate;
  updateSiteStagePositions: Array<SiteStage>;
  updateSites: Array<SiteUpdateResponse>;
  updateStage: SiteStage;
};


export type MutationAddStageArgs = {
  input: AddStageInput;
};


export type MutationArchiveProjectArgs = {
  id: Scalars['String']['input'];
};


export type MutationAssignUsersToStageArgs = {
  input: AssignUsersToStageInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateSiteLetterTemplateArgs = {
  siteLetterTemplateInput: SiteLetterTemplateInput;
};


export type MutationCreateSiteLettersArgs = {
  siteLetterInputs: Array<SiteLetterInput>;
};


export type MutationCreateThirdPartyOrderArgs = {
  input: CreateThirdPartyOrderInput;
};


export type MutationCreateThirdPartyQuoteArgs = {
  input: CreateThirdPartyQuoteInput;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProjectFileArgs = {
  fileId: Scalars['String']['input'];
};


export type MutationDeleteSiteArgs = {
  input: DeleteSiteInput;
};


export type MutationDeleteSitesInStageArgs = {
  input: DeleteSitesInStageInput;
};


export type MutationDeleteStageArgs = {
  input: DeleteStageInput;
};


export type MutationGetProjectFileUploadUrlArgs = {
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
};


export type MutationMoveAllSitesToStageArgs = {
  input: MoveAllSitesToStageInput;
};


export type MutationPlaceAtkinsOrderArgs = {
  atkinsOrderInput: AtkinsOrderInput;
};


export type MutationProcessThirdPartyOrderArgs = {
  input: ProcessThirdPartyOrderInput;
};


export type MutationRegisterProjectFileUploadArgs = {
  s3Key: Scalars['String']['input'];
};


export type MutationRestoreProjectArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendSiteLettersArgs = {
  siteLetterInputs: Array<SiteLetterInput>;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateSiteLetterTemplateArgs = {
  siteLetterTemplateInput: SiteLetterTemplateInput;
};


export type MutationUpdateSiteStagePositionsArgs = {
  input: UpdateSiteStagePositionsInput;
};


export type MutationUpdateSitesArgs = {
  input: UpdateSitesInput;
};


export type MutationUpdateStageArgs = {
  input: UpdateStageInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaperFormat {
  A4 = 'a4',
  UsLetter = 'us_letter'
}

export type Person = {
  __typename?: 'Person';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PlaceAtkinsOrderResponse = {
  __typename?: 'PlaceAtkinsOrderResponse';
  atkinsOrderId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export type ProcessThirdPartyOrderInput = {
  orderId: Scalars['String']['input'];
};

export type Project = {
  __typename?: 'Project';
  account: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  created: Scalars['DateTimeISO']['output'];
  creatorId: Scalars['String']['output'];
  developmentType: Array<DevelopmentType>;
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  lastOpened?: Maybe<Scalars['DateTimeISO']['output']>;
  modified: Scalars['DateTimeISO']['output'];
  owner?: Maybe<ProjectOwner>;
  ownerId: Scalars['String']['output'];
  sitesCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

export type ProjectFileUploadPayload = {
  __typename?: 'ProjectFileUploadPayload';
  s3Key: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type ProjectImageAntivirusScanStatusPayload = {
  __typename?: 'ProjectImageAntivirusScanStatusPayload';
  status?: Maybe<Scalars['String']['output']>;
};

export type ProjectOwner = {
  __typename?: 'ProjectOwner';
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  surname?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  address?: Maybe<Address>;
  atkinsOrder: AtkinsOrder;
  getSiteLetterImageUploadUrl: SiteLetterImageUploadUrl;
  getThirdPartyOrders: Array<ThirdPartyOrder>;
  project?: Maybe<Project>;
  projectImageAntivirusScanStatus: ProjectImageAntivirusScanStatusPayload;
  projects: Array<Project>;
  site: Site;
  siteLetter: SiteLetter;
  siteLetterImage: SiteLetterImage;
  siteLetterPaymentSummary?: Maybe<SiteLetterPaymentSummary>;
  siteLetterTemplate: SiteLetterTemplate;
  siteLetterTemplates: Array<Maybe<SiteLetterTemplate>>;
  siteLettersByGeometry: Array<SiteLetter>;
  sites: SiteConnection;
  stages: SiteStageConnection;
  thirdPartyDeliverablesBySite: Array<ThirdPartyDeliverable>;
  thirdPartyOrder?: Maybe<ThirdPartyOrder>;
  totalSiteCount: Scalars['Int']['output'];
  totalStageCount: Scalars['Int']['output'];
  validateAtkinsOrderInput: ValidateAtkinsOrderInputResponse;
};


export type QueryAddressArgs = {
  rawAddress: Scalars['String']['input'];
};


export type QueryAtkinsOrderArgs = {
  siteId: Scalars['String']['input'];
};


export type QueryGetThirdPartyOrdersArgs = {
  input: GetThirdPartyOrderInput;
};


export type QueryProjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryProjectImageAntivirusScanStatusArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryProjectsArgs = {
  archived?: Scalars['Boolean']['input'];
};


export type QuerySiteArgs = {
  siteId: Scalars['String']['input'];
};


export type QuerySiteLetterArgs = {
  siteLetterId: Scalars['String']['input'];
};


export type QuerySiteLetterImageArgs = {
  s3ObjectKey: Scalars['String']['input'];
};


export type QuerySiteLetterPaymentSummaryArgs = {
  siteLetterPaymentSummaryInput: SiteLetterPaymentSummaryInput;
};


export type QuerySiteLetterTemplateArgs = {
  siteLetterTemplateId: Scalars['String']['input'];
};


export type QuerySiteLettersByGeometryArgs = {
  siteGeometry: GeoJsonInput;
};


export type QuerySitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alertsEmailedAt?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteSort?: InputMaybe<SiteSorting>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  withPlanningAlertSubscriptionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryThirdPartyDeliverablesBySiteArgs = {
  siteId: Scalars['String']['input'];
};


export type QueryThirdPartyOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryTotalSiteCountArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTotalStageCountArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateAtkinsOrderInputArgs = {
  atkinsOrderInput: AtkinsOrderInput;
};

export type RecipientInput = {
  _id: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyOwner?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  geometry?: InputMaybe<Scalars['JSON']['input']>;
  isGranted?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  postCode: Scalars['String']['input'];
  propertyAddress: Scalars['String']['input'];
  region: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['String']['input']>;
  siteTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SharedByUser = {
  __typename?: 'SharedByUser';
  _id: Scalars['ID']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  expiresAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Site = {
  __typename?: 'Site';
  _id: Scalars['ID']['output'];
  _stage?: Maybe<SiteStage>;
  address?: Maybe<Scalars['String']['output']>;
  assignees?: Maybe<Array<Scalars['String']['output']>>;
  boundary_image: BoundaryImage;
  cached_location?: Maybe<Scalars['GeoJSON']['output']>;
  cached_location_data_lat?: Maybe<Scalars['Float']['output']>;
  cached_location_data_long?: Maybe<Scalars['Float']['output']>;
  canSendLetter?: Maybe<Scalars['Boolean']['output']>;
  collaborators: Array<Collaborator>;
  created?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['GeoJSON']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  lettersAccess: LettersAccess;
  local_authority?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  position_in_stage?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  sharedByUser?: Maybe<SharedByUser>;
  siteLetters: Array<SiteLetter>;
  site_labels?: Maybe<Array<SiteLabel>>;
  source: SiteSource;
  title?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Array<Title>>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  edges: Array<SiteConnectionEdge>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SiteConnectionEdge = {
  __typename?: 'SiteConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: Site;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type SiteLabel = {
  __typename?: 'SiteLabel';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SiteLetter = {
  __typename?: 'SiteLetter';
  created_at: Scalars['String']['output'];
  created_by: Scalars['String']['output'];
  current_status: LetterStatus;
  id: Scalars['ID']['output'];
  letter?: Maybe<Letter>;
  letter_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status_history: Array<LetterStatus>;
  team_id: Scalars['String']['output'];
  title_geometry: Scalars['GeoJSON']['output'];
};

export type SiteLetterImage = {
  __typename?: 'SiteLetterImage';
  antivirusScanStatus?: Maybe<Scalars['String']['output']>;
  s3ObjectKey: Scalars['String']['output'];
  signedDownloadUrl?: Maybe<Scalars['String']['output']>;
};

export type SiteLetterImageUploadUrl = {
  __typename?: 'SiteLetterImageUploadUrl';
  s3ObjectKey: Scalars['String']['output'];
  signedUploadUrl?: Maybe<Scalars['String']['output']>;
};

export type SiteLetterInput = {
  letter: LetterInput;
  letterName: Scalars['String']['input'];
  options?: InputMaybe<LetterOptionsInput>;
  pageCount: Scalars['Int']['input'];
  recipient: RecipientInput;
  siteBoundaryImage?: InputMaybe<Scalars['String']['input']>;
};

export type SiteLetterPaymentSummary = {
  __typename?: 'SiteLetterPaymentSummary';
  currency: CurrencyCode;
  quantity: Scalars['Int']['output'];
  siteLetterUnitPricePostTax: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  taxRate: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SiteLetterPaymentSummaryInput = {
  quantity: Scalars['Int']['input'];
};

export type SiteLetterTemplate = {
  __typename?: 'SiteLetterTemplate';
  body_text_page_1?: Maybe<Scalars['String']['output']>;
  body_text_page_2?: Maybe<Scalars['String']['output']>;
  company_logo_file_id?: Maybe<Scalars['String']['output']>;
  company_registration_number?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  greeting?: Maybe<Scalars['String']['output']>;
  /** @deprecated feature no longer supported */
  has_footer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  satellite_image_enabled?: Maybe<Scalars['Boolean']['output']>;
  sender_address_line_1?: Maybe<Scalars['String']['output']>;
  sender_city?: Maybe<Scalars['String']['output']>;
  sender_name?: Maybe<Scalars['String']['output']>;
  sender_post_code?: Maybe<Scalars['String']['output']>;
  sender_province?: Maybe<Scalars['String']['output']>;
  sign_off?: Maybe<Scalars['String']['output']>;
  signature_file_id?: Maybe<Scalars['String']['output']>;
  signature_page?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['String']['output'];
  vat_registration_number?: Maybe<Scalars['String']['output']>;
};

export type SiteLetterTemplateInput = {
  body_text_page_1?: InputMaybe<Scalars['String']['input']>;
  body_text_page_2?: InputMaybe<Scalars['String']['input']>;
  company_logo_file_id?: InputMaybe<Scalars['String']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  greeting?: InputMaybe<Scalars['String']['input']>;
  satellite_image_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sender_address_line_1?: InputMaybe<Scalars['String']['input']>;
  sender_city?: InputMaybe<Scalars['String']['input']>;
  sender_name?: InputMaybe<Scalars['String']['input']>;
  sender_post_code?: InputMaybe<Scalars['String']['input']>;
  sender_province?: InputMaybe<Scalars['String']['input']>;
  sign_off?: InputMaybe<Scalars['String']['input']>;
  signature_file_id?: InputMaybe<Scalars['String']['input']>;
  signature_page?: InputMaybe<Scalars['Int']['input']>;
  vat_registration_number?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSorting = {
  direction?: InputMaybe<Scalars['Int']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSource = {
  _id: Scalars['ID']['output'];
};

export type SiteSourceCompsLayer = SiteSource & {
  __typename?: 'SiteSourceCompsLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourceConstraintsLayer = SiteSource & {
  __typename?: 'SiteSourceConstraintsLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourceDrawingTool = SiteSource & {
  __typename?: 'SiteSourceDrawingTool';
  _id: Scalars['ID']['output'];
};

export type SiteSourceDrawingTools = SiteSource & {
  __typename?: 'SiteSourceDrawingTools';
  _id: Scalars['ID']['output'];
  drawingType?: Maybe<Scalars['String']['output']>;
};

export type SiteSourceMobileApp = SiteSource & {
  __typename?: 'SiteSourceMobileApp';
  _id: Scalars['ID']['output'];
};

export type SiteSourceOwnershipLayer = SiteSource & {
  __typename?: 'SiteSourceOwnershipLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourceOwnershipParcel = SiteSource & {
  __typename?: 'SiteSourceOwnershipParcel';
  _id: Scalars['ID']['output'];
  company_name?: Maybe<Scalars['String']['output']>;
  tenure?: Maybe<Scalars['String']['output']>;
  title_no: Scalars['String']['output'];
};

export type SiteSourceOwnershipSearch = SiteSource & {
  __typename?: 'SiteSourceOwnershipSearch';
  _id: Scalars['ID']['output'];
  search: Scalars['JSON']['output'];
};

export type SiteSourcePlanningAlertResult = SiteSource & {
  __typename?: 'SiteSourcePlanningAlertResult';
  _alert_item: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
};

export type SiteSourcePlanningLayer = SiteSource & {
  __typename?: 'SiteSourcePlanningLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePlanningPolicyLayer = SiteSource & {
  __typename?: 'SiteSourcePlanningPolicyLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePlanningSearch = SiteSource & {
  __typename?: 'SiteSourcePlanningSearch';
  _id: Scalars['ID']['output'];
  search: Scalars['JSON']['output'];
};

export type SiteSourcePropertyInfoLayer = SiteSource & {
  __typename?: 'SiteSourcePropertyInfoLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePropertySearch = SiteSource & {
  __typename?: 'SiteSourcePropertySearch';
  _id: Scalars['ID']['output'];
  search: Scalars['JSON']['output'];
};

export type SiteSourceSitesUploader = SiteSource & {
  __typename?: 'SiteSourceSitesUploader';
  _id: Scalars['ID']['output'];
  uploadId: Scalars['String']['output'];
};

export type SiteSourceZoningLayer = SiteSource & {
  __typename?: 'SiteSourceZoningLayer';
  _id: Scalars['ID']['output'];
};

export type SiteStage = {
  __typename?: 'SiteStage';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position_in_pipeline?: Maybe<Scalars['Int']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  sites: SiteConnection;
};


export type SiteStageSitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteSort?: InputMaybe<SiteSorting>;
};

export type SiteStageConnection = {
  __typename?: 'SiteStageConnection';
  edges: Array<SiteStageConnectionEdge>;
  nodes: Array<SiteStage>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SiteStageConnectionEdge = {
  __typename?: 'SiteStageConnectionEdge';
  cursor: Scalars['String']['output'];
  node: SiteStage;
};

export type SiteUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _stage?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position_in_stage?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SiteUpdateResponse = {
  __typename?: 'SiteUpdateResponse';
  site: Site;
};

export type StagePositionUpdateInput = {
  position_in_pipeline: Scalars['Int']['input'];
  stageId: Scalars['ID']['input'];
};

export enum TenureType {
  Freehold = 'FREEHOLD',
  Leasehold = 'LEASEHOLD',
  UnknownOther = 'UNKNOWN_OTHER'
}

export type ThirdPartyDeliverable = {
  __typename?: 'ThirdPartyDeliverable';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permalink?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ThirdPartyProvider>;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<SignedUrl>;
  teamId: Scalars['String']['output'];
  type: ThirdPartyDeliverableType;
  version: Scalars['Int']['output'];
};

export enum ThirdPartyDeliverableType {
  Geojson = 'GEOJSON',
  Json = 'JSON',
  Pdf = 'PDF',
  Permalink = 'PERMALINK'
}

export type ThirdPartyOrder = {
  __typename?: 'ThirdPartyOrder';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  deliverables: Array<ThirdPartyDeliverable>;
  estimatedCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  provider: ThirdPartyProvider;
  quote?: Maybe<ThirdPartyQuote>;
  siteId: Scalars['String']['output'];
  status: ThirdPartyOrderStatus;
  teamId: Scalars['String']['output'];
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalAmountInclVat: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export enum ThirdPartyOrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Placed = 'PLACED'
}

export type ThirdPartyProvider = {
  __typename?: 'ThirdPartyProvider';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ThirdPartyQuote = {
  __typename?: 'ThirdPartyQuote';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  provider: ThirdPartyProvider;
  reference: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalAmountInclVat: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type Title = {
  __typename?: 'Title';
  owners?: Maybe<Array<TitleOwnership>>;
  tenure: TenureType;
  title_no?: Maybe<Scalars['String']['output']>;
};

export type TitleOwnership = {
  __typename?: 'TitleOwnership';
  company?: Maybe<Company>;
  person?: Maybe<Person>;
};

export type UpdateProjectInput = {
  developmentType: Array<DevelopmentType>;
  goal?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateSiteStagePositionsInput = {
  stageUpdates: Array<StagePositionUpdateInput>;
};

export type UpdateSitesInput = {
  siteUpdates: Array<SiteUpdateInput>;
};

export type UpdateStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

export type UserImage = {
  file?: InputMaybe<Empty>;
  s3ObjectKey: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ValidateAtkinsOrderInputResponse = {
  __typename?: 'ValidateAtkinsOrderInputResponse';
  canAtkinsOrderBePlaced: Scalars['Boolean']['output'];
  errors: Array<Maybe<Scalars['String']['output']>>;
};

export type AllProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', archivedAt?: any | null, id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null, owner?: { __typename?: 'ProjectOwner', id: string, firstname?: string | null, surname?: string | null } | null }> };

export type ArchiveProjectMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject: { __typename?: 'Project', id: string, isArchived: boolean, archivedAt?: any | null, modified: any } };

export type ArchivedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivedProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', archivedAt?: any | null, id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null, owner?: { __typename?: 'ProjectOwner', id: string, firstname?: string | null, surname?: string | null } | null }> };

export type RestoreProjectMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreProjectMutation = { __typename?: 'Mutation', restoreProject: { __typename?: 'Project', id: string, isArchived: boolean, archivedAt?: any | null, modified: any } };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null, owner?: { __typename?: 'ProjectOwner', id: string, firstname?: string | null, surname?: string | null } | null } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null } };

export type ProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, created: any, modified: any, isArchived: boolean, lastOpened?: any | null } | null };

export type RecentProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null, owner?: { __typename?: 'ProjectOwner', id: string, firstname?: string | null, surname?: string | null } | null }> };

export type ProjectBaseFragmentFragment = { __typename?: 'Project', id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null };

export type ProjectTableRowFieldsFragment = { __typename?: 'Project', archivedAt?: any | null, id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null, owner?: { __typename?: 'ProjectOwner', id: string, firstname?: string | null, surname?: string | null } | null };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', archivedAt?: any | null, id: string, title: string, developmentType: Array<DevelopmentType>, goal?: string | null, image?: string | null, imageUrl?: string | null, sitesCount: number, created: any, modified: any, isArchived: boolean, lastOpened?: any | null, owner?: { __typename?: 'ProjectOwner', id: string, firstname?: string | null, surname?: string | null } | null }> };

export type DeleteProjectFileMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type DeleteProjectFileMutation = { __typename?: 'Mutation', deleteProjectFile: boolean };

export type GetProjectFileUploadUrlMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
}>;


export type GetProjectFileUploadUrlMutation = { __typename?: 'Mutation', getProjectFileUploadUrl: { __typename?: 'ProjectFileUploadPayload', signedUrl: string, s3Key: string } };

export type ProjectImageAntivirusScanStatusQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ProjectImageAntivirusScanStatusQuery = { __typename?: 'Query', projectImageAntivirusScanStatus: { __typename?: 'ProjectImageAntivirusScanStatusPayload', status?: string | null } };

export type RegisterProjectFileUploadMutationVariables = Exact<{
  s3Key: Scalars['String']['input'];
}>;


export type RegisterProjectFileUploadMutation = { __typename?: 'Mutation', registerProjectFileUpload: string };

export type StageFieldsFragment = { __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null, hidden?: boolean | null, ref?: string | null };

export type StageSiteFieldsFragment = { __typename?: 'Site', _id: string, title?: string | null, hidden?: boolean | null, position_in_stage?: number | null, local_authority?: string | null, created?: string | null, priority?: number | null, assignees?: Array<string> | null, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string }, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null }> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null, collaborators: Array<{ __typename?: 'Collaborator', _id?: string | null }> };

export type AddStageMutationVariables = Exact<{
  input: AddStageInput;
}>;


export type AddStageMutation = { __typename?: 'Mutation', addStage: { __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null, hidden?: boolean | null, ref?: string | null } };

export type AssignUsersToStageMutationVariables = Exact<{
  input: AssignUsersToStageInput;
}>;


export type AssignUsersToStageMutation = { __typename?: 'Mutation', assignUsersToStage: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: string | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null }> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } }> };

export type DeleteSiteMutationVariables = Exact<{
  input: DeleteSiteInput;
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite: Array<{ __typename?: 'ArchivedItem', _id: string, typename: string }> };

export type DeleteSitesInStageMutationVariables = Exact<{
  input: DeleteSitesInStageInput;
}>;


export type DeleteSitesInStageMutation = { __typename?: 'Mutation', deleteSitesInStage: Array<{ __typename?: 'ArchivedItem', _id: string, typename: string }> };

export type DeleteStageMutationVariables = Exact<{
  input: DeleteStageInput;
}>;


export type DeleteStageMutation = { __typename?: 'Mutation', deleteStage: Array<{ __typename?: 'ArchivedItem', _id: string, typename: string }> };

export type MoveAllSitesToStageMutationVariables = Exact<{
  input: MoveAllSitesToStageInput;
}>;


export type MoveAllSitesToStageMutation = { __typename?: 'Mutation', moveAllSitesToStage: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: string | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null }> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } }> };

export type UpdateSiteStagePositionsMutationVariables = Exact<{
  input: UpdateSiteStagePositionsInput;
}>;


export type UpdateSiteStagePositionsMutation = { __typename?: 'Mutation', updateSiteStagePositions: Array<{ __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null, hidden?: boolean | null, ref?: string | null }> };

export type UpdateSitesMutationVariables = Exact<{
  input: UpdateSitesInput;
}>;


export type UpdateSitesMutation = { __typename?: 'Mutation', updateSites: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, local_authority?: string | null, created?: string | null, priority?: number | null, geometry?: import('geojson').Polygon | import('geojson').MultiPolygon | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null }> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } }> };

export type UpdateStageMutationVariables = Exact<{
  input: UpdateStageInput;
}>;


export type UpdateStageMutation = { __typename?: 'Mutation', updateStage: { __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, hidden?: boolean | null, position_in_pipeline?: number | null } };

export type SiteStagesQueryVariables = Exact<{
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  stageCursor?: InputMaybe<Scalars['String']['input']>;
  stageLimit?: InputMaybe<Scalars['Int']['input']>;
  siteCursor?: InputMaybe<Scalars['String']['input']>;
  siteLimit?: InputMaybe<Scalars['Int']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SiteStagesQuery = { __typename?: 'Query', siteStages: { __typename?: 'SiteStageConnection', totalCount: number, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } | null, nodes: Array<{ __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null, hidden?: boolean | null, ref?: string | null, sites: { __typename?: 'SiteConnection', totalCount: number, edges: Array<{ __typename?: 'SiteConnectionEdge', node: { __typename?: 'Site', _id: string, title?: string | null, hidden?: boolean | null, position_in_stage?: number | null, local_authority?: string | null, created?: string | null, priority?: number | null, assignees?: Array<string> | null, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string }, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null }> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null, collaborators: Array<{ __typename?: 'Collaborator', _id?: string | null }> } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } }> } };

export type LetterTabQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type LetterTabQuery = { __typename?: 'Query', letterTab: { __typename?: 'Site', lettersAccess: { __typename?: 'LettersAccess', isGranted: boolean, reason?: LettersAccessDenyReason | null } } };

export type SelectRecipientsTableQueryVariables = Exact<{
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SelectRecipientsTableQuery = { __typename?: 'Query', selectRecipientsTable: { __typename?: 'SiteConnection', edges: Array<{ __typename?: 'SiteConnectionEdge', cursor: string, node: { __typename?: 'Site', _id: string, address?: string | null, title?: string | null, geometry?: import('geojson').Polygon | import('geojson').MultiPolygon | null, cached_location?: import('geojson').Polygon | import('geojson').MultiPolygon | null, titles?: Array<{ __typename?: 'Title', title_no?: string | null, tenure: TenureType, owners?: Array<{ __typename?: 'TitleOwnership', person?: { __typename?: 'Person', address?: string | null, name?: string | null } | null, company?: { __typename?: 'Company', name?: string | null, addresses?: Array<string | null> | null } | null }> | null }> | null, lettersAccess: { __typename?: 'LettersAccess', isGranted: boolean }, source: { __typename?: 'SiteSourceCompsLayer' } | { __typename?: 'SiteSourceConstraintsLayer' } | { __typename?: 'SiteSourceDrawingTool' } | { __typename?: 'SiteSourceDrawingTools', drawingType?: string | null } | { __typename?: 'SiteSourceMobileApp' } | { __typename?: 'SiteSourceOwnershipLayer' } | { __typename?: 'SiteSourceOwnershipParcel' } | { __typename?: 'SiteSourceOwnershipSearch' } | { __typename?: 'SiteSourcePlanningAlertResult' } | { __typename?: 'SiteSourcePlanningLayer' } | { __typename?: 'SiteSourcePlanningPolicyLayer' } | { __typename?: 'SiteSourcePlanningSearch' } | { __typename?: 'SiteSourcePropertyInfoLayer' } | { __typename?: 'SiteSourcePropertySearch' } | { __typename?: 'SiteSourceSitesUploader' } | { __typename?: 'SiteSourceZoningLayer' }, boundary_image: { __typename?: 'BoundaryImage', id: string, uri: string } } }> } };

export type SentLettersTableQueryVariables = Exact<{
  siteGeometry: GeoJsonInput;
}>;


export type SentLettersTableQuery = { __typename?: 'Query', sentLettersTable: Array<{ __typename?: 'SiteLetter', id: string, name: string, current_status: { __typename?: 'LetterStatus', status: LetterSendStatus, created_at: string }, letter?: { __typename?: 'Letter', signed_pdf_url?: string | null } | null }> };

export type ThirdPartyDeliverablesBySiteQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type ThirdPartyDeliverablesBySiteQuery = { __typename?: 'Query', thirdPartyDeliverablesBySite: Array<{ __typename?: 'ThirdPartyDeliverable', id: string, teamId: string, createdAt?: any | null, s3Key?: string | null, s3Bucket?: string | null, permalink?: string | null, filename?: string | null, type: ThirdPartyDeliverableType, version: number, provider?: { __typename?: 'ThirdPartyProvider', name: string, displayName: string } | null, signedUrl?: { __typename?: 'SignedUrl', url: string, expiresAt: string } | null }> };

export type ThirdPartyOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ThirdPartyOrderQuery = { __typename?: 'Query', thirdPartyOrder?: { __typename?: 'ThirdPartyOrder', id: string, teamId: string, siteId: string, userId: string, status: ThirdPartyOrderStatus, totalAmount?: number | null, currency: string, estimatedCompletedAt?: any | null, createdAt?: any | null, completedAt?: any | null, quote?: { __typename?: 'ThirdPartyQuote', id: string, discountPercentage?: number | null } | null, provider: { __typename?: 'ThirdPartyProvider', id: string, name: string, displayName: string }, deliverables: Array<{ __typename?: 'ThirdPartyDeliverable', id: string, teamId: string, createdAt?: any | null, s3Key?: string | null, s3Bucket?: string | null, permalink?: string | null, filename?: string | null, type: ThirdPartyDeliverableType, version: number, signedUrl?: { __typename?: 'SignedUrl', url: string, expiresAt: string } | null }> } | null };

export type TotalSiteCountQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TotalSiteCountQuery = { __typename?: 'Query', totalSiteCount: number };

export type TotalStageCountQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TotalStageCountQuery = { __typename?: 'Query', totalStageCount: number };

export const ProjectBaseFragmentFragmentDoc = gql`
    fragment ProjectBaseFragment on Project {
  id
  title
  developmentType
  goal
  image
  imageUrl
  sitesCount
  created
  modified
  isArchived
  lastOpened
}
    `;
export const ProjectTableRowFieldsFragmentDoc = gql`
    fragment ProjectTableRowFields on Project {
  ...ProjectBaseFragment
  archivedAt
  owner {
    id
    firstname
    surname
  }
}
    ${ProjectBaseFragmentFragmentDoc}`;
export const StageFieldsFragmentDoc = gql`
    fragment StageFields on SiteStage {
  _id
  name
  color
  position_in_pipeline
  hidden
  ref
}
    `;
export const StageSiteFieldsFragmentDoc = gql`
    fragment StageSiteFields on Site {
  _id
  title
  source {
    _id
  }
  site_labels {
    _id
    name
  }
  hidden
  position_in_stage
  local_authority
  created
  priority
  _stage {
    _id
  }
  assignees
  collaborators {
    _id
  }
}
    `;
export const AllProjectsDocument = gql`
    query allProjects {
  projects(archived: false) {
    ...ProjectTableRowFields
  }
}
    ${ProjectTableRowFieldsFragmentDoc}`;

/**
 * __useAllProjectsQuery__
 *
 * To run a query within a React component, call `useAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProjectsQuery(baseOptions?: Apollo.QueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProjectsQuery, AllProjectsQueryVariables>(AllProjectsDocument, options);
      }
export function useAllProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProjectsQuery, AllProjectsQueryVariables>(AllProjectsDocument, options);
        }
export function useAllProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllProjectsQuery, AllProjectsQueryVariables>(AllProjectsDocument, options);
        }
export type AllProjectsQueryHookResult = ReturnType<typeof useAllProjectsQuery>;
export type AllProjectsLazyQueryHookResult = ReturnType<typeof useAllProjectsLazyQuery>;
export type AllProjectsSuspenseQueryHookResult = ReturnType<typeof useAllProjectsSuspenseQuery>;
export type AllProjectsQueryResult = Apollo.QueryResult<AllProjectsQuery, AllProjectsQueryVariables>;
export const ArchiveProjectDocument = gql`
    mutation archiveProject($id: String!) {
  archiveProject(id: $id) {
    id
    isArchived
    archivedAt
    modified
  }
}
    `;
export type ArchiveProjectMutationFn = Apollo.MutationFunction<ArchiveProjectMutation, ArchiveProjectMutationVariables>;

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProjectMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument, options);
      }
export type ArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectMutation>;
export type ArchiveProjectMutationResult = Apollo.MutationResult<ArchiveProjectMutation>;
export type ArchiveProjectMutationOptions = Apollo.BaseMutationOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>;
export const ArchivedProjectsDocument = gql`
    query archivedProjects {
  projects(archived: true) {
    ...ProjectTableRowFields
  }
}
    ${ProjectTableRowFieldsFragmentDoc}`;

/**
 * __useArchivedProjectsQuery__
 *
 * To run a query within a React component, call `useArchivedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useArchivedProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>(ArchivedProjectsDocument, options);
      }
export function useArchivedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>(ArchivedProjectsDocument, options);
        }
export function useArchivedProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>(ArchivedProjectsDocument, options);
        }
export type ArchivedProjectsQueryHookResult = ReturnType<typeof useArchivedProjectsQuery>;
export type ArchivedProjectsLazyQueryHookResult = ReturnType<typeof useArchivedProjectsLazyQuery>;
export type ArchivedProjectsSuspenseQueryHookResult = ReturnType<typeof useArchivedProjectsSuspenseQuery>;
export type ArchivedProjectsQueryResult = Apollo.QueryResult<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>;
export const RestoreProjectDocument = gql`
    mutation restoreProject($id: String!) {
  restoreProject(id: $id) {
    id
    isArchived
    archivedAt
    modified
  }
}
    `;
export type RestoreProjectMutationFn = Apollo.MutationFunction<RestoreProjectMutation, RestoreProjectMutationVariables>;

/**
 * __useRestoreProjectMutation__
 *
 * To run a mutation, you first call `useRestoreProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProjectMutation, { data, loading, error }] = useRestoreProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreProjectMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProjectMutation, RestoreProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProjectMutation, RestoreProjectMutationVariables>(RestoreProjectDocument, options);
      }
export type RestoreProjectMutationHookResult = ReturnType<typeof useRestoreProjectMutation>;
export type RestoreProjectMutationResult = Apollo.MutationResult<RestoreProjectMutation>;
export type RestoreProjectMutationOptions = Apollo.BaseMutationOptions<RestoreProjectMutation, RestoreProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    ...ProjectBaseFragment
    owner {
      id
      firstname
      surname
    }
  }
}
    ${ProjectBaseFragmentFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    ...ProjectBaseFragment
  }
}
    ${ProjectBaseFragmentFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const ProjectDocument = gql`
    query project($projectId: String!) {
  project(id: $projectId) {
    id
    title
    developmentType
    goal
    image
    imageUrl
    created
    modified
    isArchived
    lastOpened
  }
}
    `;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> & ({ variables: ProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export function useProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectSuspenseQueryHookResult = ReturnType<typeof useProjectSuspenseQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const RecentProjectsDocument = gql`
    query recentProjects {
  projects {
    ...ProjectBaseFragment
    owner {
      id
      firstname
      surname
    }
  }
}
    ${ProjectBaseFragmentFragmentDoc}`;

/**
 * __useRecentProjectsQuery__
 *
 * To run a query within a React component, call `useRecentProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentProjectsQuery(baseOptions?: Apollo.QueryHookOptions<RecentProjectsQuery, RecentProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentProjectsQuery, RecentProjectsQueryVariables>(RecentProjectsDocument, options);
      }
export function useRecentProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentProjectsQuery, RecentProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentProjectsQuery, RecentProjectsQueryVariables>(RecentProjectsDocument, options);
        }
export function useRecentProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentProjectsQuery, RecentProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentProjectsQuery, RecentProjectsQueryVariables>(RecentProjectsDocument, options);
        }
export type RecentProjectsQueryHookResult = ReturnType<typeof useRecentProjectsQuery>;
export type RecentProjectsLazyQueryHookResult = ReturnType<typeof useRecentProjectsLazyQuery>;
export type RecentProjectsSuspenseQueryHookResult = ReturnType<typeof useRecentProjectsSuspenseQuery>;
export type RecentProjectsQueryResult = Apollo.QueryResult<RecentProjectsQuery, RecentProjectsQueryVariables>;
export const ProjectsDocument = gql`
    query projects {
  projects {
    ...ProjectBaseFragment
    archivedAt
    owner {
      id
      firstname
      surname
    }
  }
}
    ${ProjectBaseFragmentFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const DeleteProjectFileDocument = gql`
    mutation DeleteProjectFile($fileId: String!) {
  deleteProjectFile(fileId: $fileId)
}
    `;
export type DeleteProjectFileMutationFn = Apollo.MutationFunction<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>;

/**
 * __useDeleteProjectFileMutation__
 *
 * To run a mutation, you first call `useDeleteProjectFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectFileMutation, { data, loading, error }] = useDeleteProjectFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteProjectFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>(DeleteProjectFileDocument, options);
      }
export type DeleteProjectFileMutationHookResult = ReturnType<typeof useDeleteProjectFileMutation>;
export type DeleteProjectFileMutationResult = Apollo.MutationResult<DeleteProjectFileMutation>;
export type DeleteProjectFileMutationOptions = Apollo.BaseMutationOptions<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>;
export const GetProjectFileUploadUrlDocument = gql`
    mutation GetProjectFileUploadUrl($filename: String!, $mimetype: String!) {
  getProjectFileUploadUrl(filename: $filename, mimetype: $mimetype) {
    signedUrl
    s3Key
  }
}
    `;
export type GetProjectFileUploadUrlMutationFn = Apollo.MutationFunction<GetProjectFileUploadUrlMutation, GetProjectFileUploadUrlMutationVariables>;

/**
 * __useGetProjectFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetProjectFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getProjectFileUploadUrlMutation, { data, loading, error }] = useGetProjectFileUploadUrlMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      mimetype: // value for 'mimetype'
 *   },
 * });
 */
export function useGetProjectFileUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetProjectFileUploadUrlMutation, GetProjectFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetProjectFileUploadUrlMutation, GetProjectFileUploadUrlMutationVariables>(GetProjectFileUploadUrlDocument, options);
      }
export type GetProjectFileUploadUrlMutationHookResult = ReturnType<typeof useGetProjectFileUploadUrlMutation>;
export type GetProjectFileUploadUrlMutationResult = Apollo.MutationResult<GetProjectFileUploadUrlMutation>;
export type GetProjectFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetProjectFileUploadUrlMutation, GetProjectFileUploadUrlMutationVariables>;
export const ProjectImageAntivirusScanStatusDocument = gql`
    query ProjectImageAntivirusScanStatus($projectId: String!) {
  projectImageAntivirusScanStatus(projectId: $projectId) {
    status
  }
}
    `;

/**
 * __useProjectImageAntivirusScanStatusQuery__
 *
 * To run a query within a React component, call `useProjectImageAntivirusScanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectImageAntivirusScanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectImageAntivirusScanStatusQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectImageAntivirusScanStatusQuery(baseOptions: Apollo.QueryHookOptions<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables> & ({ variables: ProjectImageAntivirusScanStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables>(ProjectImageAntivirusScanStatusDocument, options);
      }
export function useProjectImageAntivirusScanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables>(ProjectImageAntivirusScanStatusDocument, options);
        }
export function useProjectImageAntivirusScanStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables>(ProjectImageAntivirusScanStatusDocument, options);
        }
export type ProjectImageAntivirusScanStatusQueryHookResult = ReturnType<typeof useProjectImageAntivirusScanStatusQuery>;
export type ProjectImageAntivirusScanStatusLazyQueryHookResult = ReturnType<typeof useProjectImageAntivirusScanStatusLazyQuery>;
export type ProjectImageAntivirusScanStatusSuspenseQueryHookResult = ReturnType<typeof useProjectImageAntivirusScanStatusSuspenseQuery>;
export type ProjectImageAntivirusScanStatusQueryResult = Apollo.QueryResult<ProjectImageAntivirusScanStatusQuery, ProjectImageAntivirusScanStatusQueryVariables>;
export const RegisterProjectFileUploadDocument = gql`
    mutation RegisterProjectFileUpload($s3Key: String!) {
  registerProjectFileUpload(s3Key: $s3Key)
}
    `;
export type RegisterProjectFileUploadMutationFn = Apollo.MutationFunction<RegisterProjectFileUploadMutation, RegisterProjectFileUploadMutationVariables>;

/**
 * __useRegisterProjectFileUploadMutation__
 *
 * To run a mutation, you first call `useRegisterProjectFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProjectFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProjectFileUploadMutation, { data, loading, error }] = useRegisterProjectFileUploadMutation({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useRegisterProjectFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<RegisterProjectFileUploadMutation, RegisterProjectFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterProjectFileUploadMutation, RegisterProjectFileUploadMutationVariables>(RegisterProjectFileUploadDocument, options);
      }
export type RegisterProjectFileUploadMutationHookResult = ReturnType<typeof useRegisterProjectFileUploadMutation>;
export type RegisterProjectFileUploadMutationResult = Apollo.MutationResult<RegisterProjectFileUploadMutation>;
export type RegisterProjectFileUploadMutationOptions = Apollo.BaseMutationOptions<RegisterProjectFileUploadMutation, RegisterProjectFileUploadMutationVariables>;
export const AddStageDocument = gql`
    mutation AddStage($input: AddStageInput!) {
  addStage(input: $input) {
    _id
    name
    color
    position_in_pipeline
    hidden
    ref
  }
}
    `;
export type AddStageMutationFn = Apollo.MutationFunction<AddStageMutation, AddStageMutationVariables>;

/**
 * __useAddStageMutation__
 *
 * To run a mutation, you first call `useAddStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStageMutation, { data, loading, error }] = useAddStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStageMutation(baseOptions?: Apollo.MutationHookOptions<AddStageMutation, AddStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStageMutation, AddStageMutationVariables>(AddStageDocument, options);
      }
export type AddStageMutationHookResult = ReturnType<typeof useAddStageMutation>;
export type AddStageMutationResult = Apollo.MutationResult<AddStageMutation>;
export type AddStageMutationOptions = Apollo.BaseMutationOptions<AddStageMutation, AddStageMutationVariables>;
export const AssignUsersToStageDocument = gql`
    mutation AssignUsersToStage($input: AssignUsersToStageInput!) {
  assignUsersToStage(input: $input) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type AssignUsersToStageMutationFn = Apollo.MutationFunction<AssignUsersToStageMutation, AssignUsersToStageMutationVariables>;

/**
 * __useAssignUsersToStageMutation__
 *
 * To run a mutation, you first call `useAssignUsersToStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersToStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUsersToStageMutation, { data, loading, error }] = useAssignUsersToStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignUsersToStageMutation(baseOptions?: Apollo.MutationHookOptions<AssignUsersToStageMutation, AssignUsersToStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUsersToStageMutation, AssignUsersToStageMutationVariables>(AssignUsersToStageDocument, options);
      }
export type AssignUsersToStageMutationHookResult = ReturnType<typeof useAssignUsersToStageMutation>;
export type AssignUsersToStageMutationResult = Apollo.MutationResult<AssignUsersToStageMutation>;
export type AssignUsersToStageMutationOptions = Apollo.BaseMutationOptions<AssignUsersToStageMutation, AssignUsersToStageMutationVariables>;
export const DeleteSiteDocument = gql`
    mutation DeleteSite($input: DeleteSiteInput!) {
  deleteSite(input: $input) {
    _id
    typename
  }
}
    `;
export type DeleteSiteMutationFn = Apollo.MutationFunction<DeleteSiteMutation, DeleteSiteMutationVariables>;

/**
 * __useDeleteSiteMutation__
 *
 * To run a mutation, you first call `useDeleteSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteMutation, { data, loading, error }] = useDeleteSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteMutation, DeleteSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteMutation, DeleteSiteMutationVariables>(DeleteSiteDocument, options);
      }
export type DeleteSiteMutationHookResult = ReturnType<typeof useDeleteSiteMutation>;
export type DeleteSiteMutationResult = Apollo.MutationResult<DeleteSiteMutation>;
export type DeleteSiteMutationOptions = Apollo.BaseMutationOptions<DeleteSiteMutation, DeleteSiteMutationVariables>;
export const DeleteSitesInStageDocument = gql`
    mutation DeleteSitesInStage($input: DeleteSitesInStageInput!) {
  deleteSitesInStage(input: $input) {
    _id
    typename
  }
}
    `;
export type DeleteSitesInStageMutationFn = Apollo.MutationFunction<DeleteSitesInStageMutation, DeleteSitesInStageMutationVariables>;

/**
 * __useDeleteSitesInStageMutation__
 *
 * To run a mutation, you first call `useDeleteSitesInStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSitesInStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSitesInStageMutation, { data, loading, error }] = useDeleteSitesInStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSitesInStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSitesInStageMutation, DeleteSitesInStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSitesInStageMutation, DeleteSitesInStageMutationVariables>(DeleteSitesInStageDocument, options);
      }
export type DeleteSitesInStageMutationHookResult = ReturnType<typeof useDeleteSitesInStageMutation>;
export type DeleteSitesInStageMutationResult = Apollo.MutationResult<DeleteSitesInStageMutation>;
export type DeleteSitesInStageMutationOptions = Apollo.BaseMutationOptions<DeleteSitesInStageMutation, DeleteSitesInStageMutationVariables>;
export const DeleteStageDocument = gql`
    mutation DeleteStage($input: DeleteStageInput!) {
  deleteStage(input: $input) {
    _id
    typename
  }
}
    `;
export type DeleteStageMutationFn = Apollo.MutationFunction<DeleteStageMutation, DeleteStageMutationVariables>;

/**
 * __useDeleteStageMutation__
 *
 * To run a mutation, you first call `useDeleteStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStageMutation, { data, loading, error }] = useDeleteStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStageMutation, DeleteStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStageMutation, DeleteStageMutationVariables>(DeleteStageDocument, options);
      }
export type DeleteStageMutationHookResult = ReturnType<typeof useDeleteStageMutation>;
export type DeleteStageMutationResult = Apollo.MutationResult<DeleteStageMutation>;
export type DeleteStageMutationOptions = Apollo.BaseMutationOptions<DeleteStageMutation, DeleteStageMutationVariables>;
export const MoveAllSitesToStageDocument = gql`
    mutation MoveAllSitesToStage($input: MoveAllSitesToStageInput!) {
  moveAllSitesToStage(input: $input) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type MoveAllSitesToStageMutationFn = Apollo.MutationFunction<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>;

/**
 * __useMoveAllSitesToStageMutation__
 *
 * To run a mutation, you first call `useMoveAllSitesToStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAllSitesToStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAllSitesToStageMutation, { data, loading, error }] = useMoveAllSitesToStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveAllSitesToStageMutation(baseOptions?: Apollo.MutationHookOptions<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>(MoveAllSitesToStageDocument, options);
      }
export type MoveAllSitesToStageMutationHookResult = ReturnType<typeof useMoveAllSitesToStageMutation>;
export type MoveAllSitesToStageMutationResult = Apollo.MutationResult<MoveAllSitesToStageMutation>;
export type MoveAllSitesToStageMutationOptions = Apollo.BaseMutationOptions<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>;
export const UpdateSiteStagePositionsDocument = gql`
    mutation UpdateSiteStagePositions($input: UpdateSiteStagePositionsInput!) {
  updateSiteStagePositions(input: $input) {
    _id
    name
    color
    position_in_pipeline
    hidden
    ref
  }
}
    `;
export type UpdateSiteStagePositionsMutationFn = Apollo.MutationFunction<UpdateSiteStagePositionsMutation, UpdateSiteStagePositionsMutationVariables>;

/**
 * __useUpdateSiteStagePositionsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteStagePositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteStagePositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteStagePositionsMutation, { data, loading, error }] = useUpdateSiteStagePositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteStagePositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteStagePositionsMutation, UpdateSiteStagePositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteStagePositionsMutation, UpdateSiteStagePositionsMutationVariables>(UpdateSiteStagePositionsDocument, options);
      }
export type UpdateSiteStagePositionsMutationHookResult = ReturnType<typeof useUpdateSiteStagePositionsMutation>;
export type UpdateSiteStagePositionsMutationResult = Apollo.MutationResult<UpdateSiteStagePositionsMutation>;
export type UpdateSiteStagePositionsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteStagePositionsMutation, UpdateSiteStagePositionsMutationVariables>;
export const UpdateSitesDocument = gql`
    mutation UpdateSites($input: UpdateSitesInput!) {
  updateSites(input: $input) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      local_authority
      created
      priority
      geometry
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type UpdateSitesMutationFn = Apollo.MutationFunction<UpdateSitesMutation, UpdateSitesMutationVariables>;

/**
 * __useUpdateSitesMutation__
 *
 * To run a mutation, you first call `useUpdateSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSitesMutation, { data, loading, error }] = useUpdateSitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSitesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSitesMutation, UpdateSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSitesMutation, UpdateSitesMutationVariables>(UpdateSitesDocument, options);
      }
export type UpdateSitesMutationHookResult = ReturnType<typeof useUpdateSitesMutation>;
export type UpdateSitesMutationResult = Apollo.MutationResult<UpdateSitesMutation>;
export type UpdateSitesMutationOptions = Apollo.BaseMutationOptions<UpdateSitesMutation, UpdateSitesMutationVariables>;
export const UpdateStageDocument = gql`
    mutation UpdateStage($input: UpdateStageInput!) {
  updateStage(input: $input) {
    _id
    name
    color
    hidden
    position_in_pipeline
  }
}
    `;
export type UpdateStageMutationFn = Apollo.MutationFunction<UpdateStageMutation, UpdateStageMutationVariables>;

/**
 * __useUpdateStageMutation__
 *
 * To run a mutation, you first call `useUpdateStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStageMutation, { data, loading, error }] = useUpdateStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStageMutation, UpdateStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStageMutation, UpdateStageMutationVariables>(UpdateStageDocument, options);
      }
export type UpdateStageMutationHookResult = ReturnType<typeof useUpdateStageMutation>;
export type UpdateStageMutationResult = Apollo.MutationResult<UpdateStageMutation>;
export type UpdateStageMutationOptions = Apollo.BaseMutationOptions<UpdateStageMutation, UpdateStageMutationVariables>;
export const SiteStagesDocument = gql`
    query siteStages($stageIds: [String], $projectId: String, $includeHidden: Boolean, $stageCursor: String, $stageLimit: Int, $siteCursor: String, $siteLimit: Int, $siteLabels: [ID], $assignees: [ID], $searchString: String, $localAuthorities: [String]) {
  siteStages: stages(
    stageIds: $stageIds
    projectId: $projectId
    includeHidden: $includeHidden
    cursor: $stageCursor
    limit: $stageLimit
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
    nodes {
      ...StageFields
      sites(
        limit: $siteLimit
        cursor: $siteCursor
        siteLabels: $siteLabels
        includeHidden: $includeHidden
        assignees: $assignees
        searchString: $searchString
        localAuthorities: $localAuthorities
      ) {
        totalCount
        edges {
          node {
            ...StageSiteFields
          }
        }
        pageInfo {
          hasNextPage
          endCursor
          startCursor
        }
      }
    }
  }
}
    ${StageFieldsFragmentDoc}
${StageSiteFieldsFragmentDoc}`;

/**
 * __useSiteStagesQuery__
 *
 * To run a query within a React component, call `useSiteStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStagesQuery({
 *   variables: {
 *      stageIds: // value for 'stageIds'
 *      projectId: // value for 'projectId'
 *      includeHidden: // value for 'includeHidden'
 *      stageCursor: // value for 'stageCursor'
 *      stageLimit: // value for 'stageLimit'
 *      siteCursor: // value for 'siteCursor'
 *      siteLimit: // value for 'siteLimit'
 *      siteLabels: // value for 'siteLabels'
 *      assignees: // value for 'assignees'
 *      searchString: // value for 'searchString'
 *      localAuthorities: // value for 'localAuthorities'
 *   },
 * });
 */
export function useSiteStagesQuery(baseOptions?: Apollo.QueryHookOptions<SiteStagesQuery, SiteStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStagesQuery, SiteStagesQueryVariables>(SiteStagesDocument, options);
      }
export function useSiteStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStagesQuery, SiteStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStagesQuery, SiteStagesQueryVariables>(SiteStagesDocument, options);
        }
export function useSiteStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteStagesQuery, SiteStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteStagesQuery, SiteStagesQueryVariables>(SiteStagesDocument, options);
        }
export type SiteStagesQueryHookResult = ReturnType<typeof useSiteStagesQuery>;
export type SiteStagesLazyQueryHookResult = ReturnType<typeof useSiteStagesLazyQuery>;
export type SiteStagesSuspenseQueryHookResult = ReturnType<typeof useSiteStagesSuspenseQuery>;
export type SiteStagesQueryResult = Apollo.QueryResult<SiteStagesQuery, SiteStagesQueryVariables>;
export const LetterTabDocument = gql`
    query letterTab($_id: String!) {
  letterTab: site(siteId: $_id) {
    lettersAccess {
      isGranted
      reason
    }
  }
}
    `;

/**
 * __useLetterTabQuery__
 *
 * To run a query within a React component, call `useLetterTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useLetterTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLetterTabQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLetterTabQuery(baseOptions: Apollo.QueryHookOptions<LetterTabQuery, LetterTabQueryVariables> & ({ variables: LetterTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LetterTabQuery, LetterTabQueryVariables>(LetterTabDocument, options);
      }
export function useLetterTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LetterTabQuery, LetterTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LetterTabQuery, LetterTabQueryVariables>(LetterTabDocument, options);
        }
export function useLetterTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LetterTabQuery, LetterTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LetterTabQuery, LetterTabQueryVariables>(LetterTabDocument, options);
        }
export type LetterTabQueryHookResult = ReturnType<typeof useLetterTabQuery>;
export type LetterTabLazyQueryHookResult = ReturnType<typeof useLetterTabLazyQuery>;
export type LetterTabSuspenseQueryHookResult = ReturnType<typeof useLetterTabSuspenseQuery>;
export type LetterTabQueryResult = Apollo.QueryResult<LetterTabQuery, LetterTabQueryVariables>;
export const SelectRecipientsTableDocument = gql`
    query selectRecipientsTable($siteIds: [ID], $stageIds: [ID], $limit: Int, $siteLabels: [ID], $searchString: String, $localAuthorities: [String], $assignees: [ID]) {
  selectRecipientsTable: sites(
    siteIds: $siteIds
    stageIds: $stageIds
    limit: $limit
    siteLabels: $siteLabels
    searchString: $searchString
    localAuthorities: $localAuthorities
    assignees: $assignees
  ) {
    edges {
      node {
        _id
        address
        title
        titles {
          title_no
          tenure
          owners {
            person {
              address
              name
            }
            company {
              name
              addresses
            }
          }
        }
        geometry
        cached_location
        lettersAccess {
          isGranted
        }
        source {
          ... on SiteSourceDrawingTools {
            drawingType
          }
        }
        boundary_image {
          id
          uri
        }
      }
      cursor
    }
  }
}
    `;

/**
 * __useSelectRecipientsTableQuery__
 *
 * To run a query within a React component, call `useSelectRecipientsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectRecipientsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectRecipientsTableQuery({
 *   variables: {
 *      siteIds: // value for 'siteIds'
 *      stageIds: // value for 'stageIds'
 *      limit: // value for 'limit'
 *      siteLabels: // value for 'siteLabels'
 *      searchString: // value for 'searchString'
 *      localAuthorities: // value for 'localAuthorities'
 *      assignees: // value for 'assignees'
 *   },
 * });
 */
export function useSelectRecipientsTableQuery(baseOptions?: Apollo.QueryHookOptions<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>(SelectRecipientsTableDocument, options);
      }
export function useSelectRecipientsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>(SelectRecipientsTableDocument, options);
        }
export function useSelectRecipientsTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>(SelectRecipientsTableDocument, options);
        }
export type SelectRecipientsTableQueryHookResult = ReturnType<typeof useSelectRecipientsTableQuery>;
export type SelectRecipientsTableLazyQueryHookResult = ReturnType<typeof useSelectRecipientsTableLazyQuery>;
export type SelectRecipientsTableSuspenseQueryHookResult = ReturnType<typeof useSelectRecipientsTableSuspenseQuery>;
export type SelectRecipientsTableQueryResult = Apollo.QueryResult<SelectRecipientsTableQuery, SelectRecipientsTableQueryVariables>;
export const SentLettersTableDocument = gql`
    query sentLettersTable($siteGeometry: GeoJSONInput!) {
  sentLettersTable: siteLettersByGeometry(siteGeometry: $siteGeometry) {
    id
    name
    current_status {
      status
      created_at
    }
    letter {
      signed_pdf_url
    }
  }
}
    `;

/**
 * __useSentLettersTableQuery__
 *
 * To run a query within a React component, call `useSentLettersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentLettersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentLettersTableQuery({
 *   variables: {
 *      siteGeometry: // value for 'siteGeometry'
 *   },
 * });
 */
export function useSentLettersTableQuery(baseOptions: Apollo.QueryHookOptions<SentLettersTableQuery, SentLettersTableQueryVariables> & ({ variables: SentLettersTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentLettersTableQuery, SentLettersTableQueryVariables>(SentLettersTableDocument, options);
      }
export function useSentLettersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentLettersTableQuery, SentLettersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentLettersTableQuery, SentLettersTableQueryVariables>(SentLettersTableDocument, options);
        }
export function useSentLettersTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SentLettersTableQuery, SentLettersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentLettersTableQuery, SentLettersTableQueryVariables>(SentLettersTableDocument, options);
        }
export type SentLettersTableQueryHookResult = ReturnType<typeof useSentLettersTableQuery>;
export type SentLettersTableLazyQueryHookResult = ReturnType<typeof useSentLettersTableLazyQuery>;
export type SentLettersTableSuspenseQueryHookResult = ReturnType<typeof useSentLettersTableSuspenseQuery>;
export type SentLettersTableQueryResult = Apollo.QueryResult<SentLettersTableQuery, SentLettersTableQueryVariables>;
export const ThirdPartyDeliverablesBySiteDocument = gql`
    query thirdPartyDeliverablesBySite($siteId: String!) {
  thirdPartyDeliverablesBySite(siteId: $siteId) {
    id
    teamId
    createdAt
    s3Key
    s3Bucket
    permalink
    filename
    type
    version
    provider {
      name
      displayName
    }
    signedUrl {
      url
      expiresAt
    }
  }
}
    `;

/**
 * __useThirdPartyDeliverablesBySiteQuery__
 *
 * To run a query within a React component, call `useThirdPartyDeliverablesBySiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyDeliverablesBySiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyDeliverablesBySiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useThirdPartyDeliverablesBySiteQuery(baseOptions: Apollo.QueryHookOptions<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables> & ({ variables: ThirdPartyDeliverablesBySiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables>(ThirdPartyDeliverablesBySiteDocument, options);
      }
export function useThirdPartyDeliverablesBySiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables>(ThirdPartyDeliverablesBySiteDocument, options);
        }
export function useThirdPartyDeliverablesBySiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables>(ThirdPartyDeliverablesBySiteDocument, options);
        }
export type ThirdPartyDeliverablesBySiteQueryHookResult = ReturnType<typeof useThirdPartyDeliverablesBySiteQuery>;
export type ThirdPartyDeliverablesBySiteLazyQueryHookResult = ReturnType<typeof useThirdPartyDeliverablesBySiteLazyQuery>;
export type ThirdPartyDeliverablesBySiteSuspenseQueryHookResult = ReturnType<typeof useThirdPartyDeliverablesBySiteSuspenseQuery>;
export type ThirdPartyDeliverablesBySiteQueryResult = Apollo.QueryResult<ThirdPartyDeliverablesBySiteQuery, ThirdPartyDeliverablesBySiteQueryVariables>;
export const ThirdPartyOrderDocument = gql`
    query thirdPartyOrder($id: String!) {
  thirdPartyOrder(id: $id) {
    id
    quote {
      id
      discountPercentage
    }
    teamId
    siteId
    userId
    status
    totalAmount
    currency
    estimatedCompletedAt
    createdAt
    completedAt
    provider {
      id
      name
      displayName
    }
    deliverables {
      id
      teamId
      createdAt
      s3Key
      s3Bucket
      permalink
      filename
      type
      version
      signedUrl {
        url
        expiresAt
      }
    }
  }
}
    `;

/**
 * __useThirdPartyOrderQuery__
 *
 * To run a query within a React component, call `useThirdPartyOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThirdPartyOrderQuery(baseOptions: Apollo.QueryHookOptions<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables> & ({ variables: ThirdPartyOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables>(ThirdPartyOrderDocument, options);
      }
export function useThirdPartyOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables>(ThirdPartyOrderDocument, options);
        }
export function useThirdPartyOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables>(ThirdPartyOrderDocument, options);
        }
export type ThirdPartyOrderQueryHookResult = ReturnType<typeof useThirdPartyOrderQuery>;
export type ThirdPartyOrderLazyQueryHookResult = ReturnType<typeof useThirdPartyOrderLazyQuery>;
export type ThirdPartyOrderSuspenseQueryHookResult = ReturnType<typeof useThirdPartyOrderSuspenseQuery>;
export type ThirdPartyOrderQueryResult = Apollo.QueryResult<ThirdPartyOrderQuery, ThirdPartyOrderQueryVariables>;
export const TotalSiteCountDocument = gql`
    query totalSiteCount($projectId: String) {
  totalSiteCount(projectId: $projectId)
}
    `;

/**
 * __useTotalSiteCountQuery__
 *
 * To run a query within a React component, call `useTotalSiteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalSiteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalSiteCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTotalSiteCountQuery(baseOptions?: Apollo.QueryHookOptions<TotalSiteCountQuery, TotalSiteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalSiteCountQuery, TotalSiteCountQueryVariables>(TotalSiteCountDocument, options);
      }
export function useTotalSiteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalSiteCountQuery, TotalSiteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalSiteCountQuery, TotalSiteCountQueryVariables>(TotalSiteCountDocument, options);
        }
export function useTotalSiteCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TotalSiteCountQuery, TotalSiteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalSiteCountQuery, TotalSiteCountQueryVariables>(TotalSiteCountDocument, options);
        }
export type TotalSiteCountQueryHookResult = ReturnType<typeof useTotalSiteCountQuery>;
export type TotalSiteCountLazyQueryHookResult = ReturnType<typeof useTotalSiteCountLazyQuery>;
export type TotalSiteCountSuspenseQueryHookResult = ReturnType<typeof useTotalSiteCountSuspenseQuery>;
export type TotalSiteCountQueryResult = Apollo.QueryResult<TotalSiteCountQuery, TotalSiteCountQueryVariables>;
export const TotalStageCountDocument = gql`
    query totalStageCount($projectId: String) {
  totalStageCount(projectId: $projectId)
}
    `;

/**
 * __useTotalStageCountQuery__
 *
 * To run a query within a React component, call `useTotalStageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalStageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalStageCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTotalStageCountQuery(baseOptions?: Apollo.QueryHookOptions<TotalStageCountQuery, TotalStageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalStageCountQuery, TotalStageCountQueryVariables>(TotalStageCountDocument, options);
      }
export function useTotalStageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalStageCountQuery, TotalStageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalStageCountQuery, TotalStageCountQueryVariables>(TotalStageCountDocument, options);
        }
export function useTotalStageCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TotalStageCountQuery, TotalStageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalStageCountQuery, TotalStageCountQueryVariables>(TotalStageCountDocument, options);
        }
export type TotalStageCountQueryHookResult = ReturnType<typeof useTotalStageCountQuery>;
export type TotalStageCountLazyQueryHookResult = ReturnType<typeof useTotalStageCountLazyQuery>;
export type TotalStageCountSuspenseQueryHookResult = ReturnType<typeof useTotalStageCountSuspenseQuery>;
export type TotalStageCountQueryResult = Apollo.QueryResult<TotalStageCountQuery, TotalStageCountQueryVariables>;